import { memo, useCallback, useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  setPrintOption,
  setPrintWidgetOpen,
} from "../../../../../redux/action/PrintWidget-action";
import { PRINT_OPTIONS } from "../../../../../redux/reducers/printWidget";
import { ConfigContext } from "../../../../../utils/ConfigContext";
import { ROLE_EDITOR, triggerGAEvent } from "../../../../../utils/helper";
import { BSBrush, BSLightning, PrintIcon } from "../../../../Icons";
import { Tooltip } from "../../../../UI";
import Section from "../UI/Section/Section";
import PrintMapProgress from "./PrintMapProgress";

const PrintMap = ({ expanded }) => {
  const { t } = useTranslation("common");
  const { config } = useContext(ConfigContext);

  const isLoading = useSelector((state) => state.printWidget.isLoading);

  const dispatch = useDispatch();

  const allowPublicCustomization = useMemo(
    () =>
      config?.printMap?.allowPublicPrintCustomisations &&
      config.role !== ROLE_EDITOR,
    // false,
    [config]
  );

  const openPrintWidget = useCallback(() => {
    if (isLoading) return;
    dispatch(setPrintWidgetOpen(true));
  }, [dispatch, isLoading]);

  const handlePrintOptionSelect = useCallback(
    (type) => {
      dispatch(setPrintOption(type));
      openPrintWidget();
    },
    [dispatch, openPrintWidget]
  );

  const options = [
    {
      icon: <BSLightning width="14" height="14" />,
      title: t("print.dropdown.quick.title"),
      onClick: () => {
        handlePrintOptionSelect(PRINT_OPTIONS.quick);
        triggerGAEvent({
          event: "widget",
          params: {
            widget_name: "Print",
            widget_type: "quick",
          },
        });
      },
      description: t("print.dropdown.quick.tooltip"),
    },
    {
      icon: <BSBrush width="14" height="14" />,
      title: t("print.dropdown.custom.title"),
      description: t("print.dropdown.custom.tooltip"),
      onClick: () => {
        handlePrintOptionSelect(PRINT_OPTIONS.custom);

        triggerGAEvent({
          event: "widget",
          params: {
            widget_name: "Print",
            widget_type: "custom",
          },
        });
      },
    },
  ];

  const handleClick = useCallback(() => {
    if (allowPublicCustomization) {
    } else {
      openPrintWidget();
    }
  }, [allowPublicCustomization, openPrintWidget]);

  if (isLoading) {
    return (
      <Tooltip
        visible={true}
        placement="right"
        content={<PrintMapProgress t={t} config={config} expanded={expanded} />}
        maxWidth="180px"
        blurred={true}
      >
        <Section
          onClick={handleClick}
          expanded={expanded}
          title={t("print.title")}
          Icon={PrintIcon}
          optionsVisible={isLoading}
        ></Section>
      </Tooltip>
    );
  }

  return (
    <Section
      className="onboarding-print"
      onClick={handleClick}
      expanded={expanded}
      options={allowPublicCustomization ? options : []}
      title={t("print.title")}
      information={t("print.information")}
      Icon={PrintIcon}
      widgetName={!allowPublicCustomization ? "Print" : undefined}
    />
  );
};

export default memo(PrintMap);
